module.exports = __webpack_public_path__ + "static/media/noimg-800x800.2d814233.jpg";